import { $themeConfig } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: $themeConfig.layout.menu.isCollapsed,
    menuList : [],
  },
  getters: {
    menuList : (state) => state.menuList
  },
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val
    },
    UPDATE_MENU_LIST(state , val) {
      state.menuList = val
    }
  },
  actions: {},
}
